import { useQuery, useQueryClient } from "@tanstack/react-query";
import { planSummaryResponseSchema } from "../../types/planning/plan.type";
import { useApiUrls } from "../useApiUrl";
import { apiUrls } from "../../utils/apiUrls";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";
import { http } from "../../utils/httpCommon";

export const plannedRoutesQueryKey = (date: number, sicId: number) => [
  "plannedRoutes",
  date,
  sicId,
];

const getRouteAssignments = async (
  date: number,
  sicId: number,
  searchTerm?: string,
  getRouteAssignmentsUrl?: string
) => {
  const url = getRouteAssignmentsUrl || "";

  const { data, status } = await http.get(url, {
    params: {
      searchTerm,
    },
  });

  if (status === 204) return [];
  return planSummaryResponseSchema.parse(data);
};

export const usePlannedRoutes = (date: number, sicId: number) => {
  const hookUrls = useApiUrls();
  const isEndpointHookEnabled = useIsFeatureFlagEnabled(
    "inbound-3763-endpoint-hook-client"
  );
  const { getRouteAssignments: getRouteAssignmentsUrl } = isEndpointHookEnabled
    ? hookUrls
    : apiUrls;
  return useQuery({
    queryKey: plannedRoutesQueryKey(date, sicId),
    queryFn: () =>
      getRouteAssignments(
        date,
        sicId,
        undefined,
        getRouteAssignmentsUrl(date, sicId)
      ),
  });
};

export function useInvalidateQueryPlannedRoutes() {
  const queryClient = useQueryClient();
  const invalidateQueryPlannedRoutes = (date: number, sicId: number) => {
    queryClient.invalidateQueries({
      queryKey: plannedRoutesQueryKey(date, sicId),
      exact: false,
    });
  };
  return invalidateQueryPlannedRoutes;
}
